import { CastFanRoom } from '@/modules/casts/classes/CastFanRoom'
import { Olympics } from '../classes'
import KisweDate from '@/modules/common/classes/KisweDate'
import { AthleteMomentData } from '@/modules/thorapi/types'

const UNDEFINED = 'xxxxxxxxxxxx'

// eslint-disable-next-line complexity
export const getFanRoomAutoClipName = (cast: CastFanRoom, clipCreateTime: Date, config: Olympics): string => {
  const dayNumStr = `${Math.ceil(KisweDate.diffDays(clipCreateTime, config.startDate ?? clipCreateTime))}`
  const dayNum = dayNumStr.padStart(2, '0').slice(0,2)
  const sportsCode = (cast.scenesSettings.athlete.discipline || UNDEFINED).slice(0,3)
  const athleteFNameInitial = (cast.scenesSettings.athlete.firstName || UNDEFINED).slice(0,1)
  const athleteLName = cast.scenesSettings.athlete.lastName || UNDEFINED
  const athleteName = `${athleteFNameInitial}${athleteLName}`.slice(0,12)
  const countryCode = (cast.scenesSettings.athlete.country ?? UNDEFINED).slice(0,3)
  const createTime = KisweDate.formatDate(clipCreateTime, 'HHmm')
  return `AMO-${dayNum}-${sportsCode}-${athleteName}-${countryCode}-${createTime}`.toLocaleUpperCase()
}

export const getFanRoomLogData = (cast: CastFanRoom): Partial<AthleteMomentData> => {
  const sportsCode = cast.scenesSettings.athlete.discipline ?? ''
  const athleteFName = cast.scenesSettings.athlete.firstName ?? ''
  const athleteLName = cast.scenesSettings.athlete.lastName ?? ''
  const athleteName = `${athleteFName} ${athleteLName}`
  const countryCode = cast.scenesSettings.athlete.country ?? ''
  const venue = cast.scenesSettings.athlete.venue ?? ''
  const isTest = cast.watermark
  let nrGuests = 0
  if (cast.programSceneId) nrGuests = cast.anonymousGuestsCount(cast.programSceneId)
  return {
    sportsCode,
    athleteName,
    countryCode,
    venue,
    nrGuests,
    isTest
  }
}
